import { useState, useEffect, useCallback } from 'react';

interface UseSectionSettingsProps {
  section: PolicyFormSection;
  questions: Record<string, PolicyFormQuestion>;
  onSave: (updates: Partial<PolicyFormSection>) => void;
  onClose: () => void;
}

function isConditionMeaningful(condition?: Condition): boolean {
  if (!condition) return false;
  if ('conditions' in condition) return condition.conditions.length > 0;
  return !!condition.field;
}

export function useSectionSettings({ section, onSave, onClose }: UseSectionSettingsProps) {
  const [title, setTitle] = useState(section.title);
  const [hasCondition, setHasCondition] = useState(!!section.conditional?.visible);
  const [condition, setCondition] = useState<Condition | undefined>(section.conditional?.visible);

  useEffect(() => {
    setTitle(section.title);
    setHasCondition(!!section.conditional?.visible);
    setCondition(section.conditional?.visible);
  }, [section]);

  const handleSave = useCallback(() => {
    const conditional: ConditionalBehavior | undefined =
      hasCondition && isConditionMeaningful(condition) ? { visible: condition } : undefined;

    onSave({ title, conditional });
    onClose();
  }, [hasCondition, condition, title, onSave, onClose]);

  return {
    title,
    setTitle,
    hasCondition,
    setHasCondition,
    condition,
    setCondition,
    handleSave,
  };
}
